import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from 'store/resources';
import { externalLogin } from 'services/auth';
import { IExternalLoginPayload, ILoginResponse } from 'services/auth/types';

export const ThunkExternalLogin = createAsyncThunk<ILoginResponse, IExternalLoginPayload>(
  `${storeResources.AUTH}/externalLogin`,
  payload => externalLogin(payload).then(r => r.data),
);
